'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _grid = require('../../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _summary = require('../../../molecules/summary');

var _summary2 = _interopRequireDefault(_summary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SummaryGroup = function (_React$Component) {
    _inherits(SummaryGroup, _React$Component);

    function SummaryGroup() {
        _classCallCheck(this, SummaryGroup);

        return _possibleConstructorReturn(this, (SummaryGroup.__proto__ || Object.getPrototypeOf(SummaryGroup)).apply(this, arguments));
    }

    _createClass(SummaryGroup, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                entities = _props.entities,
                properties = _props.properties;

            var isMobile = this.context.screen.isMobile;
            var isTablet = this.context.screen.isTablet;

            var addButtonIndex = entities ? this.props.entities.length : 0;

            var nogutterLeftAddButton = isMobile ? true : isTablet ? addButtonIndex % 2 === 0 : addButtonIndex % 3 === 0;
            var nogutterRightAddButton = isMobile ? true : isTablet ? addButtonIndex % 2 === 1 : addButtonIndex % 3 === 2;

            var hasGreaterThanOrEqualMaxItemLimit = function () {
                if (properties && properties.length) {
                    var propertiesObject = properties.find(function (prop) {
                        return prop.code === 'HasGreaterThanOrEqualMaxItemLimit';
                    });
                    if (propertiesObject) {
                        return propertiesObject.value === 'true';
                    }
                }
                return false;
            }();

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    _grid2.default,
                    null,
                    _react2.default.createElement(
                        _row2.default,
                        { nogutter: true },
                        entities && entities.length > 0 && entities.map(function (item, index) {
                            var nogutterLeft = isMobile ? true : isTablet ? index % 2 === 0 : index % 3 === 0;
                            var nogutterRight = isMobile ? true : isTablet ? index % 2 === 1 : index % 3 === 2;

                            return _react2.default.createElement(
                                _column2.default,
                                { key: index, xs: 12, md: 6, lg: 4, nogutterleft: nogutterLeft, nogutterright: nogutterRight, index: index },
                                _react2.default.createElement(_summary2.default, {
                                    code: item.code,
                                    componentCode: _this2.props.componentCode,
                                    icon: _this2.props.icon,
                                    item: item,
                                    label: _this2.props.label,
                                    allowEdit: _this2.props.allowEdit,
                                    editEvent: _this2.props.editEvent,
                                    allowDelete: _this2.props.allowDelete,
                                    deleteEvent: _this2.props.deleteEvent
                                })
                            );
                        }),
                        this.props.allowAdd === true && !hasGreaterThanOrEqualMaxItemLimit && _react2.default.createElement(
                            _column2.default,
                            { xs: 12, md: 6, lg: 4, nogutterleft: nogutterLeftAddButton, nogutterright: nogutterRightAddButton, index: addButtonIndex },
                            _react2.default.createElement(_summary2.default, {
                                mode: 'add',
                                type: this.props.type,
                                addEvent: this.props.addEvent
                            })
                        )
                    )
                )
            );
        }
    }]);

    return SummaryGroup;
}(_react2.default.Component);

SummaryGroup.contextTypes = {
    screen: _propTypes2.default.object
};

exports.default = SummaryGroup;